import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client";
import { keys } from "../api/query-registry";
import type { Todo } from "./useTodos";

// To-do queue hook — thin fetcher over GET /api/queue. Composition (the
// unified time-bucketed merge of open to-dos and virtual ICP-deadline rows)
// is computed SERVER-side in lib/queue.ts over the Resident ICP view; this
// module only declares the response contract types and the cache key.

/** A resident's current-cycle ICP deadline as a virtual queue row. */
export interface IcpQueueItem {
  kind: "icp";
  residentRef: string;
  name: string;
  bed: string | null;
  homeId: string;
  homeName: string | null;
  /** Effective deadline (ISO instant, HK midnight). */
  nextIcpDate: string | null;
  icpFillStatus: "pending_ax" | "ax_done_awaiting_form" | "form_available" | "filled" | null;
}

export type QueueItem = Todo | IcpQueueItem;

export type BucketKey = "overdue" | "today" | "this-week" | "next-week" | "this-month" | "later";

export interface QueueGroup {
  key: BucketKey;
  label: string;
  /** ICP group: virtual deadline rows plus any to-dos tagged "icp". */
  icp: QueueItem[];
  docs: Todo[];
}

export interface QueueResult {
  buckets: QueueGroup[];
  total: number;
  tagOptions: string[];
}

export function useUnifiedQueue(homeId?: string, tag?: string) {
  const h = homeId ?? "";
  const t = tag ?? "";
  const qs = new URLSearchParams();
  if (h) qs.set("homeId", h);
  if (t) qs.set("tag", t);
  return useQuery({
    queryKey: keys.todoQueue(h, t),
    queryFn: () => api<QueueResult>(`/api/queue${qs.size > 0 ? `?${qs.toString()}` : ""}`),
    staleTime: 30_000,
  });
}
